import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-md-6 mb-20" }
const _hoisted_9 = { class: "col-md-6 mb-20" }
const _hoisted_10 = { class: "col-12 mb-20" }
const _hoisted_11 = { class: "badge bg-primary" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "col-md-6 mb-20" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "col-md-6 mb-20" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-md-6 mb-20" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "col-md-6 mb-20" }
const _hoisted_21 = { class: "col-md-6 mb-20" }
const _hoisted_22 = { class: "col-md-6 mb-20" }
const _hoisted_23 = { class: "col-12 mb-20" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-12 mb-20" }
const _hoisted_26 = { class: "col-md-6 mb-20" }
const _hoisted_27 = { class: "col-md-6 mb-20" }
const _hoisted_28 = { class: "col-md-6 mb-20" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "col-md-6 mb-20" }
const _hoisted_31 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_32 = {
  type: "submit",
  class: "btn btn-success px-4 py-2"
}
const _hoisted_33 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.auth.can('ADD_CUSTOMER'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.imagepreview)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imagepreview,
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/images/NoImage.png'),
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_7)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      ref: "updateImgInput",
                      type: "file",
                      accept: "image/*",
                      class: "d-none",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-2",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                    }, " Choisir la photo "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                    }, " Annuler ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser.name) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom complet",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkName && _ctx.checkName(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.newUser.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CIN *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newUser.cin) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "CIN",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.newUser.cin]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "(Pièces Jointes) CIN", -1)),
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control shadow-none rounded-0",
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileSelected && _ctx.fileSelected(...args))),
                  multiple: "",
                  accept: "image/*"
                }, null, 32),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "mt-2"
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(attachment.name) + " (" + _toDisplayString((attachment.size / 1024 / 1024).toFixed(1)) + "MB) ", 1)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (url, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: index,
                      src: url,
                      class: "me-2 mb-2",
                      height: "120"
                    }, null, 8, _hoisted_13))
                  }), 128)),
                  (_ctx.urls.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-warning rounded-circle",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.removeFiles && _ctx.removeFiles(...args)))
                      }, " X "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse electronique *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.email) = $event)),
                  type: "email",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Adresse electronique",
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkEmail && _ctx.checkEmail(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.newUser.email]
                ]),
                (_ctx.erroremail)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_15, "Email éléctronique déja existe"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du magasin *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newUser.store) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom du magasin",
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkStore && _ctx.checkStore(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.newUser.store]
                ]),
                (_ctx.errorstore)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_17, "Magazin déja existe"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newUser.phone) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Numéro de téléphone",
                  onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.checkPhone && _ctx.checkPhone(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.newUser.phone]
                ]),
                (_ctx.errorphone)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_19, "Ce numéro téléphone déja existe"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone (Personnel)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newUser.p_phone) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Numéro de téléphone (Personnel)"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.p_phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newUser.password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Mot de passe",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.newUser.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Confirmation de mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newUser.c_password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Confirmation de mot de passe",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.newUser.c_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newUser.city) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citiesList, (c, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: c
                    }, _toDisplayString(c.name), 9, _hoisted_24))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newUser.city]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newUser.adresse) = $event)),
                  rows: "2",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Adresse",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.newUser.adresse]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Site web *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newUser.website) = $event)),
                  type: "url",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Site web *"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.website]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Marque *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newUser.brand) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Marque *"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.brand]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type d'entereprise *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newUser.client_type) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClients, (c, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: c
                    }, _toDisplayString(c.name), 9, _hoisted_29))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newUser.client_type]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Registre de commerce", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newUser.rc) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Registre de commerce"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.rc]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", _hoisted_32, [
                  _cache[40] || (_cache[40] = _createTextVNode(" Enregistrer ", -1)),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                    : _createCommentVNode("", true)
                ]),
                _cache[41] || (_cache[41] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link text-danger"
                }, " Annuler ", -1))
              ])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}